export const getBase64 = file => {
  return new Promise(resolve => {
    let baseURL = "";
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
}

export const downloadDocument = (archivo, nombrearchivo) => {
  let eseeDocs = window.open('', '_blank');
  eseeDocs.document.title = "Aurora";
  eseeDocs.document.write(`Enlace de descarga <a href=${archivo} download=${nombrearchivo} target="_blank">aquí</a>`);
}